import React from "react"

import {
  SelectedCategoriesWrapper,
  SelectedCategoriesTitle,
  SelectedCategoriesText,
} from "./styles"

const SelectedCategories = ({ id, title, options, idx }) => {
  if (!options || !options.length || !options.some(({ value }) => value)) {
    return null
  }

  return (
    <SelectedCategoriesWrapper first={idx === 0}>
      <SelectedCategoriesTitle>{title}: </SelectedCategoriesTitle>
      {options
        .filter(({ value }) => value)
        .map((option) => (
          <SelectedCategoriesText key={`review-selected-categories-${id}-text-${option.id}`}>
            {option.text.trim()}
          </SelectedCategoriesText>
        ))}
    </SelectedCategoriesWrapper>
  )
}

export default SelectedCategories
